angular.module('core')
    .component('diffDatesInDays', {
        bindings: {
            dateFrom: '<',
            dateTo: '<',
            plusDays: '<'
        },
        template: `
            <span ng-if="$ctrl.diffDays != null && $ctrl.diffDays >= 0">Pozostało [dni]:&nbsp;{{$ctrl.diffDays}}</span>
            <span ng-if="$ctrl.diffDays != null && $ctrl.diffDays < 0" style="color: red; font-weight: bold;">Po terminie [dni]:&nbsp;{{$ctrl.diffDays * (-1)}}</span>
        `,
        controller: function () {
            let DateDiff = {
                inDays(d1, d2) {
                    let t2 = d2.getTime();
                    let t1 = d1.getTime();

                    return Math.floor((t2 - t1) / (24 * 3600 * 1000));
                },

                inWeeks(d1, d2) {
                    let t2 = d2.getTime();
                    let t1 = d1.getTime();

                    return parseInt((t2 - t1) / (24 * 3600 * 1000 * 7));
                },

                inMonths(d1, d2) {
                    let d1Y = d1.getFullYear();
                    let d2Y = d2.getFullYear();
                    let d1M = d1.getMonth();
                    let d2M = d2.getMonth();

                    return (d2M + 12 * d2Y) - (d1M + 12 * d1Y);
                },

                inYears(d1, d2) {
                    return d2.getFullYear() - d1.getFullYear();
                }
            }

            this.$onInit = () => {
                if (!this.dateTo)
                    this.dateTo = new Date();

                if(this.dateFrom == null){
                    this.diffDays = null;
                    return;
                }

                if (!this.plusDays)
                    this.plusDays = 0;

                this.dateFrom = new Date(this.dateFrom);
                this.dateFrom.setDate(this.dateFrom.getDate() + this.plusDays);

                this.diffDays = DateDiff.inDays(new Date(this.dateTo), this.dateFrom)
            }
        }
    })
